import React from 'react'

import { Sidebar } from 'components/Sidebar'

import { useSidebarLocalCache } from '../../components/Sidebar/hooks/useSidebarLocalCache'
import {
  StyledAsideLayout,
  StyledFullWidthBackgroundContainer,
  StyledMaxWidthContainer,
} from './DashboardLayout.styled'

interface Props {
  children: React.ReactNode
}

export const DashboardLayout = ({ children }: Props) => {
  const { isFolded } = useSidebarLocalCache()

  return (
    <StyledFullWidthBackgroundContainer>
      <StyledMaxWidthContainer>
        <StyledAsideLayout isSideBarOpen={!isFolded} aside={<Sidebar />}>
          {children}
        </StyledAsideLayout>
      </StyledMaxWidthContainer>
    </StyledFullWidthBackgroundContainer>
  )
}
